import React from 'react';
import styled from 'styled-components';
const StyledFlex = styled.div `
    display: flex;
    flex-direction: ${props => (props.column ? 'column' : 'row')};
    align-items: ${props => props.alignItems};
    justify-content: ${props => props.justifyContent};
    padding: ${props => props.padding};
    margin: ${props => props.margin};
    flex: ${props => props.flex};
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    flex-wrap: ${props => props.flexWrap};
`;
const Flex = ({ className, children, column, alignItems, justifyContent, padding, margin, flex, fullWidth, flexWrap, }) => (React.createElement(StyledFlex, { className: className, column: column, alignItems: alignItems, justifyContent: justifyContent, padding: padding, margin: margin, fullWidth: fullWidth, flex: flex, flexWrap: flexWrap }, children));
export default Flex;
